import React from 'react';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { useIntl } from 'react-intl';
import './AffiliatePage.css';
import IconAboutSvg from '../../components/IconAboutSvg/IconAboutSvg';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const AffiliatePage = () => {
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'AffiliatePage.title' });
  const descrptionSection = intl.formatMessage({ id: 'AffiliatePage.descrptionSection' });
  const descrptionSection1 = intl.formatMessage({ id: 'AffiliatePage.descrptionSection1' });
  const descrptionSection2 = intl.formatMessage({ id: 'AffiliatePage.descrptionSection2' });
  const history = useHistory()

  // history.push(`${process.env.REACT_APP_MARKETPLACE_ROOT_URL}/signup?referral_code=YourName`)}
  return (
    <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>

    <Page title="" scrollingDisabled={false}>
      <div >
          <div className="aboutpageContainer">
            <div className="aboutpageDescriptionContainer">
              <h2>{title}</h2>
              <p>{descrptionSection}</p>
              <p>{descrptionSection1}</p>
              <p>{descrptionSection2}</p>

            </div>
            <div className="aboutImage">
            <button className={"primaryBtnNew"}onClick={() => history.push(`/signup?referral_code=YourName`)}>Join Now</button>

              <IconAboutSvg />
            </div>
          </div>
      </div>
    </Page>
    </LayoutSingleColumn>

  );
};

export default AffiliatePage;
